export default "__VITE_ASSET__fQyoR3m0eA3DLqol7kyoXA__";